/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import axios from "axios";
import { APIGateways } from "../../../utility/APIGateways";
import { getAuthHeader } from "../../../utility/auth";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";

const COMPONENT_NAME = "Admin webChatManager/services/ConfigService";

/**
 * Takes in an object containing the chat config to either update or delete in the AWS DynamoDB.
 * @param {*} updateObject This object contains either "updateConfig" or "deleteConfig". Depending on which
 * the given config will either be updated or deleted in the dynamo db.
 */
export const updateConfigAsync = async (updateObject) => {
	try {
		let updateResponse = await axios.post(`${APIGateways.webChatConfigEndpoint}`, updateObject, {
			headers: await getAuthHeader(),
		});
		return updateResponse.data;
	} catch (error) {
		v2.error(`Error updating web chat config value`, {
			additionalData: { error: errorToObject(error), data: { updateObject } },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.UPDATE_WEBCHAT_CONFIG_API_ERROR,
		});
		throw error;
	}
};

/**
 * This service gets all of the web chat configurations for the PACE account.
 */
export const getConfigsAsync = async () => {
	try {
		let configs = await axios.get(`${APIGateways.webChatConfigEndpoint}`, {
			headers: await getAuthHeader(),
		});
		return configs.data.results;
	} catch (error) {
		v2.error(`Error getting web chat configs`, {
			additionalData: { error: errorToObject(error) },
			componentName: COMPONENT_NAME,
			logCode: errorCodes.GET_WEBCHAT_CONFIG_API_ERROR,
		});
		throw error;
	}
};
